import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useCanonicalLink = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const baseUrl = window.config?.canonicalBaseUrl ?? window.location.origin;
    const canonicalUrl = `${baseUrl.replace(/\/$/, '')}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }, [pathname]);
};

export default useCanonicalLink;
